import { EllipsisWithTooltip, tokens } from '@cast/design-system';
import {
  isEmptyMetricValue,
  type SloMetric,
} from '@cast/features-cluster-shared';

type SloMetricCellProps = {
  metric?: SloMetric;
};

export const SloMetricCell = ({ metric }: SloMetricCellProps) => {
  if (!metric || isEmptyMetricValue(metric.value)) {
    return (
      <EllipsisWithTooltip
        TypographyProps={{
          variant: 'P12R',
          sx: { color: tokens.theme.disabled.fg, fontStyle: 'italic' },
        }}
      >
        {metric?.value ?? '--'}
      </EllipsisWithTooltip>
    );
  }

  const valueColor =
    metric.status === 'breached'
      ? tokens.theme.fg.status.error
      : metric.status === 'at_risk'
      ? tokens.theme.fg.status.warning
      : tokens.theme.fg.structural.primary;

  const unitSuffix = metric.unit
    ? metric.unit === '%'
      ? metric.unit
      : ` ${metric.unit}`
    : '';

  return (
    <EllipsisWithTooltip
      TypographyProps={{
        variant: 'P12R',
        sx: { color: valueColor },
      }}
    >
      {metric.value}
      {unitSuffix}
    </EllipsisWithTooltip>
  );
};
